import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { IVolunteerShift, isVolunteerBoardDisabledError } from './models';

export const VOLUNTEER_SHIFTS_KEY = '/volunteering/shifts';

export const useVolunteerShiftsQuery = ({
	activityId,
	enabled = true,
	impersonationContext,
}: {
	activityId?: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!activityId,
		queryKey: [VOLUNTEER_SHIFTS_KEY, activityId, impersonationContext?.account?.id],
		queryFn: async () => {
			const value = await userSession.webServiceHelper.callAsync<IVolunteerShift[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/activities/${activityId}/shifts`,
				}),
				'GET'
			);
			return value ?? [];
		},
		meta: {
			toastErrorMessage: (error: Error) => (isVolunteerBoardDisabledError(error) ? '' : 'Failed to load shifts'),
		},
	});
};

export const invalidateVolunteerShifts = (activityId?: string) =>
	reactQueryClient.invalidateQueries({
		queryKey: activityId ? [VOLUNTEER_SHIFTS_KEY, activityId] : [VOLUNTEER_SHIFTS_KEY],
	});
